module.exports = __webpack_public_path__ + "static/media/9x12no2-min.79b45d95.jpg";